<template>
  <div class="text-input-container">
    <label :for="inputId" :class="{ active: isFocused || inputValue, focused: isFocused, error: isRequired && !isValid }">{{ label }}</label>
    <input 
      :id="inputId"
      type="text"
      v-model="inputValue"
      @focus="isFocused = true" 
      @blur="isFocused = false"
      :class="{ error: isRequired && !isValid }"
    />
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      inputValue: this.modelValue,
      isFocused: false,
      isValid: true,
      inputId: `input-${Math.random().toString(36).substr(2, 9)}` 
    };
  },
  watch: {
    modelValue(newVal) {
      this.inputValue = newVal; 
    },
    inputValue(newVal) {
      this.$emit('update:modelValue', newVal); 
      this.validateInput();
    }
  },
  methods: {
    validateInput() {
      this.isValid = !(this.required && !this.inputValue.trim());
    }
  }
};
</script>

<style scoped>
.text-input-container {
  position: relative;
  margin-top: 20px;
}

input {
  border: 1px solid var(--input-border-color);
  border-radius: 4px;
  padding: 10px;
  font-size: 0.85rem;
  outline: none;
  width: 100%;
  height: 40px;
  transition: border-color 0.3s;
}

input:focus {
  border-color: var(--logo-color);
}

label {
  position: absolute;
  font-size: 14px;
  font-weight: 300;
  top: 45%;
  left: 10px;
  transform: translateY(-50%);
  color: var(--border-color);
  transition: 0.3s;
  background-color: transparent;
  padding: 0 4px;
  cursor: text; 
}

label.active {
  top: 0px;
  left: 5px;
  font-size: 12px;
  background-color: white;
}

label.focused {
  font-weight: 400;
  color: var(--logo-color); 
}

input:focus + label {
  color: var(--logo-color); 
}

input:not(:focus) + label.active {
  color: var(--input-text-color); 
}

input.error {
  border-color: red;
}

label.error {
  color: red; 
}

</style>
